<section>
  <div class="header astral-page-header">
    <h1>{{ 'COMMON.CREDIT_BALANCE' | translate }}</h1>
    <astral-popover [helpText]="'INVOICE.HEADER_TOOLTIP.CONTACT_BALANCE_TRANSACTION'"></astral-popover>
  </div>
  <app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>
  <app-multiselect-list-view
    [columnDefinition]="columnDefinitions"
    [itemsSource]="itemsSource"
    [menuDefinition]="menuDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [preferencesKey]="preferencesKey"
    [rememberPagination]="true"
    [isToolbarSticky]="true"
  ></app-multiselect-list-view>
</section>
